import { motion } from "framer-motion";

const pillars = [
  {
    n: "01",
    title: "Anamnesi corporea",
    desc: "Ogni percorso parte da un'analisi completa: misure, abitudini, obiettivi. Niente si lascia al caso.",
  },
  {
    n: "02",
    title: "Scheda 100% su misura",
    desc: "Allenamento costruito sui tuoi attrezzi, i tuoi tempi e il tuo livello. Nessun piano copia-incolla.",
  },
  {
    n: "03",
    title: "Alimentazione flessibile",
    desc: "Consigli alimentari sostenibili e, nei pacchetti Trimestrale, Semestrale e Annuale, schede rinnovate gratis ogni 45 giorni per non stallare mai.",
  },
];

const fadeUp = {
  initial: { opacity: 0, y: 28 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, amount: 0.15 },
};

export default function MethodSection() {
  return (
    <section id="metodo" className="py-24 px-5 sm:px-8">
      <div className="max-w-7xl mx-auto">
        <motion.div {...fadeUp} transition={{ duration: 0.7 }} className="mb-14">
          <p className="font-mono text-[11px] uppercase tracking-[0.35em] text-blood font-semibold mb-4">// Il metodo</p>
          <h2 className="font-display font-black uppercase text-4xl sm:text-5xl lg:text-6xl leading-[0.95]">
            Nessuna scusa.
            <br />
            Solo <span className="text-blood">metodo.</span>
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-12 gap-4">
          <motion.div {...fadeUp} transition={{ duration: 0.7 }} className="md:col-span-5 relative min-h-[380px] md:min-h-[520px] group">
            <img
              src="/coach-method.jpg"
              alt="Coach DisciplinaFit concentrato durante l'allenamento"
              loading="lazy"
              data-testid="method-coach-photo"
              className="absolute inset-0 w-full h-full object-cover object-top contrast-125 saturate-[0.85] transition-transform duration-700 group-hover:scale-[1.02]"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-ink-deep via-transparent to-transparent" />
            <div className="absolute bottom-5 left-5 border-l-2 border-blood pl-3">
              <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-blood font-semibold">Focus &amp; mentalità</p>
              <p className="font-display font-bold uppercase text-white text-xl leading-tight">La disciplina si allena ogni giorno</p>
            </div>
          </motion.div>

          <div className="md:col-span-7 grid gap-4">
            {pillars.map((p, i) => (
              <motion.div
                key={p.n}
                {...fadeUp}
                transition={{ duration: 0.6, delay: i * 0.12 }}
                className="bg-ink-surface border border-white/10 hover:border-blood/50 p-7 sm:p-9 transition-colors duration-300"
                data-testid={`method-pillar-${p.n}`}
              >
                <div className="flex items-start gap-6">
                  <span className="font-mono text-blood font-bold text-lg">{p.n}</span>
                  <div>
                    <h3 className="font-display font-extrabold uppercase text-2xl sm:text-3xl tracking-tight">{p.title}</h3>
                    <p className="mt-2 text-neutral-300 text-sm sm:text-base leading-relaxed max-w-xl">{p.desc}</p>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
